<template>
  <div>
    <router-view></router-view>
    <footer>
      <cookie-law storageType="cookie" theme="base"></cookie-law>
    </footer>
  </div>
</template>


<script ref="AppRoot">
import footerComponent from "./components/footerComponent.vue";
import CookieLaw from 'vue-cookie-law'
import {
  mdbContainer,
  mdbRow,
  mdbCol
} from 'mdbvue';

import {store} from './store'
import NavBarComponent from "./components/NavBarComponent";
import {eventBus} from './main'

export default {
  name: "app",
  components: {
    NavBarComponent, CookieLaw,
    mdbContainer,
    footerComponent,
    mdbRow,
    mdbCol
  },

  data() {
    return {
      stateNavBar: false,
      hideStateNavBar: localStorage.hideStateNavBar,
      signedIn: false
    };
  },

  methods: {
    // a computed getter
    getHideStateNavBar() {
      // console.log('ezzeze', localStorage.hideStateNavBar);
      // `this` points to the vm instance
      if (localStorage.hideStateNavBar === 'false') {
        // console.log('falsefalse', false);
        return false
      }
      if (localStorage.hideStateNavBar === 'true') {
        // console.log('truetrue', true);
        return true
      }
      if (!localStorage.hideStateNavBar) {
        // console.log('doesnt exist');
        return true
      }
      return localStorage.hideStateNavBar
    }
  },
  created() {
    document.title = "YourSynchronicity"
  },

  // mounted() {
  //     this.stateNavBar = this.$route.path.includes('linkedin')
  // }
};
</script>
<style lang="scss">
@import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
</style>
